import React, { ReactNode, useContext, useState } from 'react'
import { ErrorBoundary } from '@sentry/react'
// @ts-expect-error TS(2306) FIXME: File '/Users/cedric/Dev/repositories/toktokdoc/wor... Remove this comment to see the full error message
import ToktokdocLib from '@saas/lib/toktokdoc-lib/web'
import { useLocation, useSearchParams } from 'react-router-dom'
import CssBaseline from '@mui/material/CssBaseline'
import clsx from 'clsx'
import { CircularProgress, Typography } from '@mui/material'
import { useGetIdsHealthcareservicesHcsId } from '@toktokdoctech/tokapi-client'
import TokTokDocSnackbar from '../components/Common/Snackbar'
import useStyles from './_styles'
import { initApi } from '../api/auth'
import { CurrentHcsContext } from '../components/feature/hcs/CurrentHcsProvider/CurrentHcsContext'
import RouterOutsideContainer from '../routers/RouterOutsideContainer'
import { ParseGuardExternal } from '../components/legacy/ParseGuardExternal'

export const External = ({ children }: { children: ReactNode }) => {
    const classes = useStyles()
    const { pathname } = useLocation()
    const [searchParams] = useSearchParams()
    const hcsId = searchParams.get('hcsId')

    const { currentHcs, setCurrentHcs } = useContext(CurrentHcsContext)
    const [token, setToken] = useState(null)

    // The embedding app (caregiver, manager) owns the establishment and passes it in the URL.
    // It is never picked here: the user already chose it in the host app.
    const {
        data: hcs,
        isLoading: isLoadingHcs,
        error: hcsError,
    } = useGetIdsHealthcareservicesHcsId(hcsId ?? '', { query: { enabled: !!hcsId } })

    React.useEffect(() => {
        if (hcs) setCurrentHcs(hcs)
    }, [hcs, setCurrentHcs])

    /**
     * @description handler called when react-native-app send auth info
     */
    const onRNMessage = React.useCallback(async ({ detail }: any) => {
        await initApi()
        await ToktokdocLib.Auth.Login(detail.token)
        setToken(detail.token)
    }, [])

    /**
     * @description handler called when web app send auth info
     */
    const onWebMessage = React.useCallback(
        (message: any) => {
            // here check if detail and token are available because there is a lot of postMessage with monitoring etc.
            if (message.data && message.data.detail && message.data.detail.token) {
                onRNMessage(message.data)
            }
        },
        [onRNMessage],
    )

    /**
     * @description handle called on window.onload event
     * it dispatch 'signin' event to any
     */
    const onLoad = React.useCallback(() => {
        window.parent.postMessage(
            JSON.stringify({
                action: 'signin',
            }),
            `*`,
        )
        // listen web post message
        window.addEventListener('message', onWebMessage)
    }, [onWebMessage])

    React.useEffect(() => {
        // don't call web handler if from from react-native-app
        // @ts-expect-error TS(2339) FIXME: Property 'ReactNativeWebView' does not exist on ty... Remove this comment to see the full error message
        if (!window.ReactNativeWebView) {
            onLoad()
        }

        return () => {
            window.removeEventListener('message', onWebMessage)
        }
    }, [onLoad, onWebMessage])

    React.useEffect(() => {
        window.scrollTo(0, 0)
    }, [pathname])

    React.useEffect(() => {
        // @ts-expect-error TS(2339) FIXME: Property 'ReactNativeWebView' does not exist on ty... Remove this comment to see the full error message
        if (window.ReactNativeWebView) {
            window.addEventListener('rnmessage', onRNMessage, true)
            // @ts-expect-error TS(2339) FIXME: Property 'ReactNativeWebView' does not exist on ty... Remove this comment to see the full error message
            window.ReactNativeWebView.postMessage(
                JSON.stringify({
                    action: 'signin',
                }),
            )
        }

        return () => {
            window.removeEventListener('rnmessage', onRNMessage)
        }
    }, [onRNMessage])

    if (!hcsId || hcsError) {
        return (
            <RouterOutsideContainer>
                <Typography fontWeight={600} fontSize="1.6rem">
                    Impossible de charger l'établissement.
                </Typography>
            </RouterOutsideContainer>
        )
    }

    // Hold until the context matches the URL, not merely until it is set: on an hcsId
    // change the previous establishment lingers for one render after the query resolves.
    if (isLoadingHcs || currentHcs?.id !== hcsId) {
        return (
            <RouterOutsideContainer>
                <CircularProgress size="3.6rem" />
            </RouterOutsideContainer>
        )
    }

    return (
        <ParseGuardExternal token={token}>
            <div className={clsx(classes.appContainer, classes.appContainerExternal)}>
                <CssBaseline />
                <ErrorBoundary>
                    <div>
                        <div className={clsx(classes.ContainerContent, classes.ContainerContentExternal)}>
                            {children}
                        </div>
                    </div>
                </ErrorBoundary>
                <ErrorBoundary>
                    <TokTokDocSnackbar />
                </ErrorBoundary>
            </div>
        </ParseGuardExternal>
    )
}
